import "./navbar.css";
import { useState, useRef, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

const Navbar = ({ navActive, setNavActive }) => {
  const [isNavOpen, setIsNavOpen] = useState(true);

  const navMenu = useRef(null);

  const navLinks = ["home", "about", "experience", "portfolio", "contact"];

  const htmlElement = document.documentElement;

  const windowWidth = window.innerWidth;

  useEffect(() => {
    if (windowWidth > 991) {
      setIsNavOpen(true);
    } else {
      setIsNavOpen(false);
    }
  }, [windowWidth]);

  return (
    <nav className="navigation">
      <Row className="align-items-center">
        <Col
          lg={2}
          md={6}
          sm={6}
          xs={6}
          className="nav-brand d-flex justify-content-start align-items-center"
        >
          <h1>
            <span>{"<N/>"}</span> Nika Gogelia
          </h1>
        </Col>
        <Col
          md={6}
          sm={6}
          xs={6}
          className="nav-menu-button d-lg-none d-flex d-md-flex d-sm-flex justify-content-end align-items-center"
        >
          <button className="menu-button d-flex justify-content-center align-items-center">
            <img
              width={40}
              height={40}
              className="animate__animated"
              ref={navMenu}
              onClick={() => {
                setIsNavOpen(!isNavOpen);
                navMenu.current.classList.add("animate__fadeIn");
                setTimeout(
                  () => navMenu.current.classList.remove("animate__fadeIn"),
                  400
                );
              }}
              src={
                isNavOpen
                  ? "./assets/icons/close.svg"
                  : "./assets/icons/menu.svg"
              }
              alt="menu-icon"
            />
          </button>
        </Col>
        <Col
          lg={8}
          md={9}
          sm={9}
          xs={9}
          className={`nav-links ${isNavOpen ? "menu-open" : "menu-closed"}`}
        >
          <ul className="d-flex justify-content-lg-center justify-content-md-start align-items-center">
            {navLinks.map((link) => (
              <li key={link}>
                <a
                  href={`#${link}`}
                  onClick={() => {
                    setNavActive(`${link}`);
                    htmlElement.classList = "smooth-navigation";
                    setTimeout(
                      () => (htmlElement.classList = "lenis lenis-smooth"),
                      1000
                    );
                  }}
                  className={navActive === link ? "nav-active" : null}
                >
                  <span>{"<"}</span>
                  {link}
                  <span>{"/>"}</span>
                </a>
              </li>
            ))}
          </ul>
        </Col>
        <Col
          lg={2}
          md={3}
          sm={3}
          xs={3}
          className={`nav-social-links ${
            isNavOpen ? "menu-open" : "menu-closed"
          }`}
        >
          <ul className="d-flex justify-content-end align-items-center">
            <li>
              <a
                className="d-flex justify-content-center align-items-center"
                href="https://github.com/NikaGogelia"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-github"></i>
              </a>
            </li>
            <li>
              <a
                className="d-flex justify-content-center align-items-center"
                href="https://www.linkedin.com/in/nika-gogelia-003661198/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-linkedin-in"></i>
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </nav>
  );
};

export default Navbar;
